<template lang="pug">
  .container.container--reviews.yotpo-reviews__carousel-wrapper
    .yotpo-reviews__carousel-nav
      icon-button(
        class="carousel-nav__prev"
        label="Previous Slide"
        :icon="$mq === 'mobile' ? 'chevron-left' : 'chevron-left-big'"
        :size="$mq === 'mobile' ? '16px' : '64px'"
        @click="slidePrev"
      )
      icon-button(
        class="carousel-nav__next"
        label="Next Slide"
        :icon="$mq === 'mobile' ? 'chevron-right' : 'chevron-left-big'"
        :size="$mq === 'mobile' ? '16px' : '64px'"
        @click="slideNext"
      )
    carousel.yotpo-reviews__carousel(
      ref="carousel"
      :slides-to-show="['mobile', 'tablet'].includes($mq) ? 1 : 3"
      :center-mode="true"
      :infinite="true"
      v-if="topReviews.length > 0"
    )
      slide.yotpo-reviews__review(
        v-for="(review, index) in topReviews"
        :key="review.id + index"
      )
        .yotpo-reviews__review-header
          .yotpo-reviews__review-avitar {{ review.user.display_name[0] }}
            icon.yotpo-reviews__review-checkmark(
              name="check"
              size="18px"
            )
          .yotpo-reviews__review-buyer
            .yotpo-reviews__review-buyer-info
              .yotpo-reviews__review-buyer-name
                | {{ review.user.display_name }}
                span.yotpo-reviews__review-buyer-verified Verified Buyer
            star-rating.yotpo-reviews__review-buyer-rating(
              :rating="review.score"
            )
        h3.yotpo-reviews__review-title {{ review.title }}
        p.yotpo-reviews__review-contents(
          v-html="review.content"
        )
        .yotpo-reviews__review-info
          .yotpo-reviews__review-date {{ cleanDate(review.created_at) }}
          .yotpo-reviews__review-rating(
            v-if="displayRatings === 'yes'"
          )
            icon(
              name="yotpo-thumbsup"
              width="24px"
              height="24px"
            )
            span.yotpo-reviews__review-rating-amount {{ review.votes_up }}
            icon(
              name="yotpo-thumbsdown"
              width="24px"
              height="24px"
            )
            span.yotpo-reviews__review-rating-amount {{ review.votes_down }}
</template>

<script>
  import TopReviews from 'scripts/mixins/storeReviews.js';

  import StarRating from 'scripts/components/basic/StarRating.vue';
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import IconButton from 'scripts/components/buttons/IconButton.vue'
  import Icon from 'scripts/components/basic/Icon.vue'

  export default {
    name: 'ReviewsCarousel',
    mixins: [ TopReviews ],
    components: { StarRating, Carousel, Slide, IconButton, Icon },
    props: {
      displayRatings: String,
    },
    methods: {
      /**
       * Takes in a Yotpo formatted date and returns a clean user friendly version
       *
       * @param {String} rawDate: the date from Yotpo
       *
       * @return {String}: the cleaned date
       */
      cleanDate(rawDate) {
        const date = new Date(rawDate);
        return date.toLocaleDateString(date.getTimezoneOffset(), {
          month: "numeric",
          day: "numeric",
          year: "2-digit",
        });
      },
      slidePrev() {
        this.$refs.carousel.slidePrev();
      },
      slideNext() {
        this.$refs.carousel.slideNext();
      },
    }
  };
</script>

<style lang="scss" scoped>
  .yotpo-reviews__carousel-wrapper {
    position: relative;
  }

  .carousel-nav__next,
  .carousel-nav__prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    .icon {
      fill: $color-indigo;
    }
  }

  .carousel-nav__prev {
    left: 0px;
  }

  .carousel-nav__next {
    right: 0px;

    @include tablet-up {
      transform: scaleX(-1) translateY(-50%);
    }
  }

  .yotpo-reviews__review {
    padding: 0;
    font-family: $font-gibson;

    @include tablet-up() {
      padding: 0 $grid-gutter;
    }
  }

  .yotpo-reviews__review-header {
    display: flex;
  }

  .yotpo-reviews__review-avitar {
    position: relative;
    margin-right: 10px;
    border-radius: 100%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-pink;
    color: $color-indigo;
    font-size: 25px;
    line-height: 25px;

    .yotpo-reviews__review-checkmark {
      position: absolute;
      bottom: 0;
      right: 0;
      border: 1px solid $color-white;
      border-radius: 100%;
      padding: 1px;
      fill: $color-white;
      background-color: $color-indigo;
    }
  }

  .yotpo-reviews__review-buyer-info {
    display: flex;
    align-items: center;
  }

  .yotpo-reviews__review-buyer-name,
  .yotpo-reviews__review-buyer-verified {
    font-size: rem(13);
    line-height: 1.5;
    font-weight: 500;
    color: $color-charcoal;
  }

  .yotpo-reviews__review-buyer-verified {
    margin-left: 8px;
    font-weight: 400;
  }

  .yotpo-reviews__review-title {
    margin: 6px 0 0;
    font-size: rem(16);
    line-height: 1.56;
    color: $color-charcoal;
  }

  .yotpo-reviews__review-contents {
    margin-top: 0;
    flex-grow: 1;
    font-size: rem(13);
    line-height: 1.56;
    color: $color-charcoal;
  }

  .yotpo-reviews__review-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .yotpo-reviews__review-rating {
    display: flex;
    align-items: center;
  }

  .yotpo-reviews__review-date,
  .yotpo-reviews__review-rating-amount {
    font-size: rem(14);
    line-height: 1.3;
    color: $color-charcoal;
  }

  .yotpo-reviews__review-rating-amount {
    margin: 0 8px;
  }

  @include mobile-only() {
    .yotpo-reviews__carousel-nav {
      .carousel-nav__prev,
      .carousel-nav__next {
        top: -60px;
        transform: none;
      }

      .carousel-nav__prev {
        left: auto;
        right: 48px;
      }

      .carousel-nav__next {
        right: 16px;
      }
    }
  }
</style>
